import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { CenterBox, LeftBox, SpaceBetweenBox } from "./commons/BoxAbstraction";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import useGAEventsTracker from "./GAEventsHook";

const BannerSection = ({ data, setShowMeeting }) => {
  const GAEventsTracker = useGAEventsTracker(data.gaEvents.category);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <SpaceBetweenBox>
      <Box sx={{ maxWidth: "60%" }}>
        <Typography variant={isSmallScreen ? "h1Mobile" : "h1"}>
          {data.title}
        </Typography>
        <Typography
          variant={isSmallScreen ? "h4Mobile" : "body1"}
          mt={isSmallScreen ? 1 : 2}
        >
          {data.description}
        </Typography>
        <LeftBox
          gap={isSmallScreen ? "6px" : "16px"}
          sx={{
            marginY: isSmallScreen ? "16px" : "40px",
            flexWrap: isSmallScreen ? "wrap" : "",
          }}
        >
          {data.features.map((each) => (
            <Box
              key={each.text}
              sx={{
                borderRadius: isSmallScreen ? "4px" : "8px",
                background: "#fff",
                padding: "4px",
                minWidth: isSmallScreen ? "80px" : "230px",
              }}
            >
              <LeftBox>
                <CenterBox
                  sx={{
                    background: "#D9EAF3",
                    borderRadius: isSmallScreen ? "4px" : "8px",
                    marginRight: isSmallScreen ? "6px" : "10px",
                    height: isSmallScreen ? "14px" : "44px",
                    width: isSmallScreen ? "14px" : "44px",
                  }}
                >
                  {each.logo}
                </CenterBox>
                <Typography variant={isSmallScreen ? "body1Mobile" : ""}>
                  {each.text}
                </Typography>
              </LeftBox>
            </Box>
          ))}
        </LeftBox>
        {data.buttonText === "Book Now" ? (
          <Button
            variant={isSmallScreen ? "mobile" : "contained"}
            sx={{
              padding: isSmallScreen ? "4px 4px 4px 8px" : "4px 4px 4px 24px",
            }}
            onClick={() => {
              GAEventsTracker(data.gaEvents.action, "successfully");
              setShowMeeting(true);
            }}
          >
            {data.buttonText}
            <ArrowForwardIcon
              sx={{
                borderRadius: isSmallScreen ? "4px" : "12px",
                background: "white",
                fill: "#3567D6",
                width: isSmallScreen ? "20px" : "44px",
                height: isSmallScreen ? "20px" : "44px",
                marginLeft: isSmallScreen ? "8px" : "12px",
              }}
            />
          </Button>
        ) : (
          <Button
            variant={isSmallScreen ? "mobile" : "contained"}
            sx={{
              padding: isSmallScreen ? "4px 4px 4px 8px" : "4px 4px 4px 24px",
            }}
            onClick={() => {
              GAEventsTracker(data.gaEvents.action, "successfully");
              window.open(data.link);
            }}
          >
            {data.buttonText}
            <ArrowForwardIcon
              sx={{
                borderRadius: isSmallScreen ? "4px" : "12px",
                background: "white",
                fill: "#3567D6",
                width: isSmallScreen ? "20px" : "44px",
                height: isSmallScreen ? "20px" : "44px",
                marginLeft: isSmallScreen ? "8px" : "12px",
              }}
            />
          </Button>
        )}
      </Box>
      <Box sx={{ textAlign: "center" }}>
        <Box
          component="img"
          alt="products-image"
          src={`/images/${data.image}`}
          sx={{ width: data.styles.imageWidth }}
        />
      </Box>
    </SpaceBetweenBox>
  );
};

export default BannerSection;
